import {
  Autocomplete,
  Box,
  CircularProgress,
  InputAdornment,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomPagination from "../CustomPagination";
import { GET_PROJECT_BILLING_TABLE } from "../../../constants/ApiRoute";
import { authHeader } from "../../comman/MainFunction";
import { deCryptFun, enCryptFun } from "../../comman/CustomFunction";
import API from "../../comman/API";
import sortupdownarrowIcon from "../../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../../images/sort_down_arrow.svg";
import NoRecordFound from "../../comman/NoRecordFound";

export default function ProjectBillingTable(props) {
  const { customerTab, setCustomerTab } = props;
  const [sortedData, setSortedData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const [totalPages, setTotalPages] = useState(0);
  const [sortConfig, setSortConfig] = useState({
    key: "BillingHeaderID",
    direction: "asc",
  });
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("");

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  console.log(orderBy, "sortedDatasortedDatasortedData");
  console.log(searchQuery, "searchQuerysortedDatasortedDatasortedData");
  console.log(sortedData, "123445sortedDatasortedDatasortedData");

  const handleSearchChange = (event, value) => {
    setSearchQuery(value);
    setPage(1); // Reset to page 1 when search query changes
  };

  const fieldsToSearch = [
    "rowGroup",
    "BillingHeaderID",
    "BillDate",
    "LastModifiedDate",
    "BillingType",
    "Hours",
    "Status",
    "Total",
    "Description",
  ];

  const getProjectBillingDetails = async (custId, projId) => {
    setLoading(true);
    let data = {
      customerId: customerTab?.customerId ? customerTab?.customerId : custId,
      projectId: customerTab?.projectId ? customerTab?.projectId : projId,
      sort: order,
      orderBy: orderBy,
    };
    const config = {
      method: "GET",
      url: GET_PROJECT_BILLING_TABLE,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        //       const transformedData = data
        // .map((item) => ({
        //   ...item,
        // }))
        // .sort((a, b) => {
        //   // Sort by BillDate in descending order (recent dates first)
        //   return new Date(b.BillDate) - new Date(a.BillDate);
        // });
        setSortedData(data);
        setTotalPages(Math.ceil(data.length / rowsPerPage));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProjectBillingDetails(customerTab?.customerId, customerTab?.projectId);
  }, [customerTab, order, orderBy]);

  const groupedData = sortedData.reduce((acc, item) => {
    const key = `${item.ProjID}-${item.RowGroup}`;
    if (!acc[key]) {
      acc[key] = {
        rowGroup: item.RowGroup,
        items: [],
      };
    }
    acc[key].items.push(item);
    return acc;
  }, {});

  const groupedArray = Object.values(groupedData);

  const flattenedArray = groupedArray.flatMap((group) =>
    group.items.map((item) => ({
      ...item,
      rowGroup: group.rowGroup,
    }))
  );

  const filteredData = flattenedArray.filter((item) =>
    fieldsToSearch.some((field) => {
      const fieldValue = item[field];

      // Format numbers to 2 decimal places for comparison if applicable
      const formattedValue =
        typeof fieldValue === "number"
          ? fieldValue.toFixed(2)
          : String(fieldValue);

      return formattedValue.includes(searchQuery);
    })
  );

  const filteredData123 = sortedData.filter((item) => {
    return fieldsToSearch.some((field) => {
      const fieldValue = item[field];
      const formattedValue =
        typeof fieldValue === "number"
          ? fieldValue.toFixed(2)
          : String(fieldValue);

      console.log(
        `Checking field: ${field}, Formatted Value: ${formattedValue}, Search Query: ${searchQuery}`
      );

      // Check if formattedValue exists and matches the searchQuery
      return formattedValue.includes(searchQuery);
    });
  });

  // const sortedAndFilteredData = React.useMemo(() => {
  //   let sortableItems = [...filteredData];
  //   if (sortConfig !== null) {
  //     sortableItems.sort((a, b) => {
  //       if (a[sortConfig.key] < b[sortConfig.key]) {
  //         return sortConfig.direction === "asc" ? -1 : 1;
  //       }
  //       if (a[sortConfig.key] > b[sortConfig.key]) {
  //         return sortConfig.direction === "asc" ? 1 : -1;
  //       }
  //       return 0;
  //     });
  //   }
  //   return sortableItems;
  // }, [filteredData, sortConfig]);

  useEffect(() => {
    if (order == "") {
      setTotalPages(Math.ceil(filteredData.length / rowsPerPage));
    } else {
      setTotalPages(Math.ceil(filteredData123.length / rowsPerPage));
    }
  }, [filteredData]);

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    (page - 1) * rowsPerPage + rowsPerPage
  );
  const paginatedData1 = filteredData123.slice(
    (page - 1) * rowsPerPage,
    (page - 1) * rowsPerPage + rowsPerPage
  );

  console.log(paginatedData, "paginatedDatapaginatedData");
  console.log(filteredData123, "filteredData123filteredData123");
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";

    let orderValue = isAsc ? "desc" : "asc";

    setOrder(orderValue);
    setOrderBy(property);

    if (order === "desc") {
      setOrder("");
      setOrderBy("");
    }

    if (orderBy != property) {
      setOrder("asc");
      setOrderBy(property);
    }

    setPage(1);
    // setSortClickedTime(new Date().toLocaleString());

    // setSortConfig((prevState) => ({
    //   key,
    //   direction: prevState.direction === "asc" ? "desc" : "asc",
    // }));
  };

  const getSortIcon = (orderByValue) => {
    if (orderBy === orderByValue) {
      return order === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  const handleBillingNavigate = (val) => {
    if (val.BillingHeaderID) {
      const url = `/print-dashboard-billing-statements/${val.BillingHeaderID}`;
      window.open(url, "_blank"); // Opens the URL in a new tab
    }
  };

  return (
    <div>
      <Stack
        sx={{ mb: "20px" }}
        direction={{ xs: "column", sm: "row", md: "row" }}
        alignItems={{ xs: "baseline", sm: "center", md: "center" }}
        justifyContent="space-between"
      >
        <Autocomplete
          sx={{ maxWidth: "265px", width: "100%" }}
          freeSolo
          id="free-solo-2-demo"
          disableClearable
          startAdornment={
            <InputAdornment position="start">
              <span className="material-symbols-outlined">search</span>
            </InputAdornment>
          }
          options={[]}
          onInputChange={handleSearchChange}
          renderInput={(params) => (
            <TextField
              placeholder="Search"
              {...params}
              InputProps={{
                ...params.InputProps,
                type: "search",
              }}
            />
          )}
        />
      </Stack>
      <TableContainer sx={{ boxShadow: "none" }} component={Paper}>
        <Table
          // sx={{ minWidth: 650 }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "BillingHeaderID"}
                  direction={orderBy === "BillingHeaderID" ? order : "asc"}
                  onClick={() => handleSort("BillingHeaderID")}
                  IconComponent={() => getSortIcon("BillingHeaderID")}
                  style={
                    orderBy === "BillingHeaderID" ? { color: "#007fff" } : {}
                  }
                  // active={sortConfig.key === "BillingHeaderID"}
                  // direction={
                  //   sortConfig.key === "BillingHeaderID"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("BillingHeaderID")}
                >
                  ID
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "BillDate"}
                  direction={orderBy === "BillDate" ? order : "asc"}
                  onClick={() => handleSort("BillDate")}
                  IconComponent={() => getSortIcon("BillDate")}
                  style={orderBy === "BillDate" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "BillDate"}
                  // direction={
                  //   sortConfig.key === "BillDate" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("BillDate")}
                >
                  Bill Date
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "LastModifiedDate"}
                  direction={orderBy === "LastModifiedDate" ? order : "asc"}
                  onClick={() => handleSort("LastModifiedDate")}
                  IconComponent={() => getSortIcon("LastModifiedDate")}
                  style={
                    orderBy === "LastModifiedDate" ? { color: "#007fff" } : {}
                  }
                  // active={sortConfig.key === "LastModifiedDate"}
                  // direction={
                  //   sortConfig.key === "LastModifiedDate"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("LastModifiedDate")}
                >
                  Last Modified
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "BillingType"}
                  direction={orderBy === "BillingType" ? order : "asc"}
                  onClick={() => handleSort("BillingType")}
                  IconComponent={() => getSortIcon("BillingType")}
                  style={orderBy === "BillingType" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "BillingType"}
                  // direction={
                  //   sortConfig.key === "BillingType"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("BillingType")}
                >
                  Bill Type
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "Hours"}
                  direction={orderBy === "Hours" ? order : "asc"}
                  onClick={() => handleSort("Hours")}
                  IconComponent={() => getSortIcon("Hours")}
                  style={orderBy === "Hours" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "Hours"}
                  // direction={
                  //   sortConfig.key === "Hours" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("Hours")}
                >
                  Hours
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "Status"}
                  direction={orderBy === "Status" ? order : "asc"}
                  onClick={() => handleSort("Status")}
                  IconComponent={() => getSortIcon("Status")}
                  style={orderBy === "Status" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "Status"}
                  // direction={
                  //   sortConfig.key === "Status" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("Status")}
                >
                  Status
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "Total"}
                  direction={orderBy === "Total" ? order : "asc"}
                  onClick={() => handleSort("Total")}
                  IconComponent={() => getSortIcon("Total")}
                  style={orderBy === "Total" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "Total"}
                  // direction={
                  //   sortConfig.key === "Total" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("Total")}
                >
                  Line Total
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "Description"}
                  direction={orderBy === "Description" ? order : "asc"}
                  onClick={() => handleSort("Description")}
                  IconComponent={() => getSortIcon("Description")}
                  style={orderBy === "Description" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "Description"}
                  // direction={
                  //   sortConfig.key === "Description"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("Description")}
                >
                  Description
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <CircularProgress disableShrink />
                </TableCell>
              </TableRow>
            ) : paginatedData.length > 0 &&
              orderBy == "" &&
              searchQuery == "" ? (
              paginatedData.map((val, index) => (
                <React.Fragment key={index}>
                  {index === 0 ||
                  paginatedData[index - 1].rowGroup !== val.rowGroup ? (
                    <TableRow>
                      <TableCell colSpan={8} padding="0px !important">
                        <Box
                          className="datebox-title"
                          sx={{ padding: "13px !important" }}
                        >
                          <Typography>{val.rowGroup}</Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : null}
                  <TableRow>
                    <TableCell
                      sx={
                        val.BillingHeaderID
                          ? {
                              color: "#007FFF !important",
                              cursor: "pointer",
                              textDecoration: "underline",
                            }
                          : {}
                      }
                      onClick={() => handleBillingNavigate(val)}
                    >
                      {val.BillingHeaderID ? val.BillingHeaderID : "-"}
                    </TableCell>
                    <TableCell>{val.BillDate ? val.BillDate : "-"}</TableCell>
                    <TableCell>
                      {val.LastModifiedDate ? val.LastModifiedDate : "-"}
                    </TableCell>
                    <TableCell>
                      {val.BillingType ? val.BillingType : "-"}
                    </TableCell>
                    <TableCell>
                      {val.Hours ? val.Hours.toFixed(2) : "0.00"}
                    </TableCell>
                    <TableCell sx={{ minWidth: "187px" }}>
                      <span
                        // className={val.Status ? "dashboard-status-btn" : ""}
                        className={
                          val.status == "Invoice Started"
                            ? "dashboard-status-btn"
                            : val.status == "Statement Open"
                            ? "active-btn"
                            : val.status == "Statement Closed" ||
                              val.status == "Statement Ready"
                            ? "closed-btn"
                            : val.status == "Invoice Closed"
                            ? "active-btn"
                            : ""
                        }
                      >
                        {val.status ? val.status : "-"}
                      </span>
                    </TableCell>
                    <TableCell sx={{ fontWeight: "700 !important" }}>
                      {" "}
                      ${val.Total ? val.Total.toFixed(2) : "0.00"}{" "}
                    </TableCell>
                    <TableCell>
                      <span style={{ wordBreak: "break-all" }}>
                        {val.Description ? val.Description : "-"}
                      </span>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            ) : (paginatedData1.length > 0 && orderBy != "") ||
              (paginatedData1?.length > 0 && searchQuery != "") ? (
              paginatedData1.map((val, index) => (
                <React.Fragment key={index}>
                  <TableRow>
                    <TableCell colSpan={8} padding="0px !important">
                      <Box
                        className="datebox-title"
                        sx={{ padding: "13px !important" }}
                      >
                        <Typography>{val.RowGroup}</Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      sx={
                        val.BillingHeaderID
                          ? {
                              color: "#007FFF !important",
                              cursor: "pointer",
                              textDecoration: "underline",
                            }
                          : {}
                      }
                      onClick={() => handleBillingNavigate(val)}
                    >
                      {val.BillingHeaderID ? val.BillingHeaderID : "-"}
                    </TableCell>
                    <TableCell>{val.BillDate ? val.BillDate : "-"}</TableCell>
                    <TableCell>
                      {val.LastModifiedDate ? val.LastModifiedDate : "-"}
                    </TableCell>
                    <TableCell>
                      {val.BillingType ? val.BillingType : "-"}
                    </TableCell>
                    <TableCell>
                      {val.Hours ? val.Hours.toFixed(2) : "0.00"}
                    </TableCell>
                    <TableCell>
                      <span
                        // className={val.Status ? "dashboard-status-btn" : ""}
                        className={
                          val.status == "Invoice Started"
                            ? "dashboard-status-btn"
                            : val.status == "Statement Open"
                            ? "active-btn"
                            : val.status == "Statement Closed" ||
                              val.status == "Statement Ready"
                            ? "closed-btn"
                            : val.status == "Invoice Closed"
                            ? "active-btn"
                            : ""
                        }
                      >
                        {val.status ? val.status : "-"}
                      </span>
                    </TableCell>
                    <TableCell sx={{ fontWeight: "700 !important" }}>
                      {" "}
                      ${val.Total ? val.Total.toFixed(2) : "0.00"}{" "}
                    </TableCell>
                    <TableCell>
                      <span style={{ wordBreak: "break-all" }}>
                        {val.Description ? val.Description : "-"}
                      </span>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  {/* <Typography>No Record Found</Typography> */}
                  <NoRecordFound />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {filteredData.length > 0 && (
          <Pagination
            sx={{ mt: "13.5px", float: "right" }}
            shape="rounded"
            // hidePrevButton
            // hideNextButton
            count={totalPages}
            page={page}
            onChange={handlePageChange}
          />
        )}
      </TableContainer>
    </div>
  );
}
